import React from 'react';
import workload1 from '@assets/svg/icons/workload1.svg';
import DateFormatPipe from '@root/components/utilities/DateFormatPipe';

const CisaKevAlert = ({ data }) => {
  if (!data || data.length === 0) {
    // return <p>No data available</p>;
    return <p>-</p>;
  }

  return (
    <div
      style={{
        width: '100%',
        backgroundColor: '#FFF4F4',
        borderRadius: '4px',
        marginBottom: '16px',
        padding: '10px 15px 10px 15px',
        marginRight: '0.7rem',
      }}>
      <p style={{ marginTop: '8px' }}>
        <img
          src={workload1}
          style={{
            width: '11px',
            height: '10px',
            top: '400px',
            left: '15px',
            marginBottom: '0.2rem',
          }}
          alt="workload icon"
        />
        <span
          style={{
            color: '#1A202C',
            fontWeight: 600,
            fontSize: '14px',
            lineHeight: '19.12px',
            fontFamily: 'Manrope',
            marginLeft: '0.5rem',
          }}>
          {data.vulnerabilityName || 'No vulnerability name available'}
        </span>
      </p>

      <p
        style={{
          color: '#1A202C',
          fontSize: '14px',
          fontWeight: 500,
          margin: '8px 0 0',
          lineHeight: '19.12px',
        }}>
        Action: {data.shortDescription || 'No description available'}
      </p>

      <p
        style={{
          color: '#1A202C',
          fontSize: '14px',
          fontWeight: 500,
          margin: '8px 0 0',
          lineHeight: '19.12px',
        }}>
        Date Added: {DateFormatPipe(data.dateAdded) || 'No date added available'}
      </p>

      <p
        style={{
          color: '#1A202C',
          fontSize: '14px',
          fontWeight: 500,
          marginBottom: '8px',
          lineHeight: '19.12px',
        }}>
        Due Date: {data.dueDate || 'No due date available'}
      </p>
    </div>
  );
};

export default CisaKevAlert;
